<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ReportHeader from './components/ReportHeader.vue';
import TabBar from 'dashboard/components-next/tabbar/TabBar.vue';
import LeadsReport from './components/crm/LeadsReport.vue';
import DealsReport from './components/crm/DealsReport.vue';
import SalesReport from './components/crm/SalesReport.vue';
import ProductsReport from './components/crm/ProductsReport.vue';
import ObjectivesReport from './components/crm/ObjectivesReport.vue';

const { t } = useI18n();

const activeTabIndex = ref(0);

const tabs = computed(() => [
  { label: t('CRM_REPORTS.TABS.LEADS'), key: 'leads' },
  { label: t('CRM_REPORTS.TABS.DEALS'), key: 'deals' },
  { label: t('CRM_REPORTS.TABS.SALES'), key: 'sales' },
  { label: t('CRM_REPORTS.TABS.PRODUCTS'), key: 'products' },
  { label: t('CRM_REPORTS.TABS.OBJECTIVES'), key: 'objectives' },
]);

const currentTab = computed(() => tabs.value[activeTabIndex.value]);

const onTabChanged = (tab) => {
  const index = tabs.value.findIndex(t => t.key === tab.key);
  if (index !== -1) {
    activeTabIndex.value = index;
  }
};
</script>

<template>
  <div class="flex flex-col h-full">
    <ReportHeader
      :header-title="$t('CRM_REPORTS.HEADER')"
      :header-description="$t('CRM_REPORTS.DESCRIPTION')"
    />

    <div class="px-8 py-4">
      <TabBar
        :tabs="tabs"
        :initial-active-tab="activeTabIndex"
        @tab-changed="onTabChanged"
      />
    </div>

    <div class="flex-1 px-8 pb-8 overflow-auto">
      <LeadsReport v-if="currentTab.key === 'leads'" />

      <DealsReport v-if="currentTab.key === 'deals'" />

      <SalesReport v-if="currentTab.key === 'sales'" />

      <ProductsReport v-if="currentTab.key === 'products'" />

      <ObjectivesReport v-if="currentTab.key === 'objectives'" />
    </div>
  </div>
</template>
